import React from "react";
import { useIntl } from "react-intl";
import { Row, Button, Space } from "@masterteam/mt-design-react";
import useIsAr from "../../../Hooks/useIsAr";
import { ReactComponent as RightIcon } from "../../../assets/images/arrow-point-to-right.svg";
import { ReactComponent as LeftIcon } from "../../../assets/images/arrow-left.svg";

function Footer({
  stepNumber,
  totalSteps,
  isLastStep,
  formik,
  previous,
  setIsDraft,
  isReadOnly,
  isAddKpiProcess,
}) {
  const [isAr] = useIsAr();
  const intl = useIntl();

  return (
    <Row
      className={`wizard-footer ${isAr && "rtl"}`}
      justify="between"
      align="center"
    >
      {stepNumber > 0 ? (
        <Button
          className="kpi-wizard-back-button"
          onClick={() => previous(formik.values)}
          Icon={LeftIcon}
          variant="primary"
          fill="none"
          shape="square"
        />
      ) : (
        <div style={{ width: 30 }} />
      )}
      <div className="circle-container">
        {Array.from(Array(totalSteps)).map((_, index) => (
          <React.Fragment key={`step-${index}`}>
            {index > 0 && (
              <span
                className="circle-line"
                style={{
                  backgroundColor:
                    stepNumber >= index ? "var(--primary-color)" : "#f2f2f2",
                }}
              />
            )}
            <div
              className="circle"
              style={{
                borderColor:
                  stepNumber >= index ? "var(--primary-color)" : "#f2f2f2",
              }}
            >
              {index + 1}
            </div>
          </React.Fragment>
        ))}
      </div>
      <Space>
        {isAddKpiProcess && isLastStep && !isReadOnly && (
          <Button
            className="kpi-wizard-next-button"
            type="submit"
            Icon={isLastStep ? null : RightIcon}
            variant="primary"
            fill={isLastStep ? "full" : "none"}
            shape={isLastStep ? "default" : "square"}
            loading={formik.isSubmitting}
            disabled={isLastStep && !formik.isValid}
            onClick={() => {
              setIsDraft(true);
            }}
          >
            {intl.formatMessage({
              id: "common.save-as-draft",
            })}
          </Button>
        )}

        {!(isLastStep && isReadOnly) && (
          <Button
            className="kpi-wizard-next-button"
            type="submit"
            Icon={isLastStep ? null : RightIcon}
            variant="primary"
            fill={isLastStep ? "full" : "none"}
            shape={isLastStep ? "default" : "square"}
            loading={formik.isSubmitting}
            disabled={isLastStep && !formik.isValid}
            onClick={() => setIsDraft(false)}
          >
            {isLastStep
              ? intl.formatMessage({
                  id: isAddKpiProcess ? "common.submit" : "common.add",
                })
              : null}
          </Button>
        )}
      </Space>
    </Row>
  );
}

export default Footer;
